import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "fishSales";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    fishSalesList: {
      list: [],
      total: 0,
    },
  },
  actions: {
    //周期批次
    async getPondUnclearedBatchNo (a, pondId) {
      let result = await api.get(
        `/api/FishBatch/GetPondUnclearedBatchNo/${pondId}`
      );
      return result.data;
    },
    //查询-----获取成鱼销售所有数据
    async getfishSalesData ({ commit }, payload) {
      let result = await api.get(
        `/api/FishSale?${queryString.stringify(payload)}`
      );
      let fiterList = result.data.list.map((item) => {
        if (item.specType == 14000) {
          item.specType = "斤/尾";
        } else if (item.specType == 14001) {
          item.specType = "尾/斤";
        } else if (item.specType == 14002) {
          item.specType = "万尾";
          item.quantity = item.quantity / 10000;
        }else if (item.specType == 14003) {
          item.specType = "尾";
        }
        return item;
      });
      if (result.status === 200) {
        commit("setfishSalesList", result.data);
      }
      return result;
    },
    //查询-----获取成鱼销售所有数据
    async getfishSalesDataV2 ({ commit }, payload) {
      let result = await api.get(
        `/api/FishSale/GetDetalis?${queryString.stringify(payload)}`
      );
      result.data.list.forEach((listItem) => {
        listItem.detalis.map((item) => {
          if (item.specType == 14000) {
            item.specType = "斤/尾";
          } else if (item.specType == 14001) {
            item.specType = "尾/斤";
          } else if (item.specType == 14002) {
            item.specType = "万尾";
            item.detailQuantity = item.detailQuantity / 10000;
          }else if (item.specType == 14003) {
            item.specType = "尾";
          }
          return item;
        });
      });
      if (result.status === 200) {
        commit("setfishSalesList", result.data);
      }
      return result;
    },
    //添加
    async addFishSales (a, payload) {
      let result = await api.post("/api/FishSale", payload);
      return result.data;
    },
    //删除数据
    async delFishSalesList (a, payload) {
      let result = await api.delete(`/api/FishSale/` + payload);
      return result;
    },
    //删除数据
    async delFishSalesDetail (a, payload) {
      let result = await api.delete(`/api/FishSale/detail/${payload}`);
      return result;
    },
    //编辑---获取单行数据
    async getFishSalesData (a, payload) {
      let result = await api.get(`/api/FishSale/` + payload);
      let fiterList = result.data.details.map((item) => {
        if (item.specType == 14002) {
          item.quantity = item.quantity / 10000;
        }
        return item;
      });
      return result.data;
    },
    //修改
    async updateFishSales (a, payload) {
      let result = await api.put(`/api/FishSale/${payload.id}`, payload.data);
      return result.data;
    },
  },
  mutations: {
    //分页数据
    setfishSalesList (state, payload) {
      state.fishSalesList = payload;
    },
  },
  getters: {},
});

export default moduleName;
